"use client";

import React, { useRef } from "react";
import { ArrowUpRight, ChevronLeft, ChevronRight, Sparkles } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
const leaders = [{
  name: "RICARDO CASTILLO",
  role: "Presidente",
  bio: "Sirviendo a la fraternidad global con dedicación a la plantación de iglesias, la formación bíblica y el fortalecimiento ministerial.",
  image: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=46c7qex549z",
  srcset: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=q9adk9tbsm-wvc-srcset",
  sizes: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=jhaql2bdb3a-wvc-sizes"
}, {
  name: "RICK DUBOSE",
  role: "Superintendente General Asistente",
  bio: "Comprometido con la supervisión ejecutiva, el crecimiento organizacional y las iniciativas de multiplicación de iglesias en todo el mundo.",
  image: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=064r7fnqdzg6",
  srcset: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=85g8owmz2nc-wvc-srcset",
  sizes: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=ho2dmp8u9o-wvc-sizes"
}, {
  name: "BRAD KESLER",
  role: "Secretario General",
  bio: "Supervisando la acreditación ministerial, las estadísticas eclesiásticas y el gobierno ejecutivo en los presbiterios regionales.",
  image: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=udvw3r239dl",
  srcset: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=y9zqzc31vx-wvc-srcset",
  sizes: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=pm6vfigqnz-wvc-sizes"
}, {
  name: "RICK ROSS",
  role: "Tesorero General",
  bio: "Administrando los recursos financieros, las estrategias de desarrollo y las iniciativas internacionales de compasión.",
  image: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=wk60zwdi2bp",
  srcset: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=hvr5uu90e5r-wvc-srcset",
  sizes: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=kawknqkst2n-wvc-sizes"
}, {
  name: "MARCOS SILVA",
  role: "Director de Misiones Globales",
  bio: "Impulsando la expansión transcultural y el apoyo logístico para los misioneros en regiones no alcanzadas.",
  image: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=is6d5q39u6",
  srcset: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=ni18ug7h57o-wvc-srcset",
  sizes: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=0ex9agjkz2fr-wvc-sizes"
}, {
  name: "ELENA MENDOZA",
  role: "Directora de Educación Teológica",
  bio: "Coordinando los planes de estudio y la capacitación continua para institutos bíblicos y seminarios asociados.",
  image: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=loy8yrkr2d",
  srcset: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=yqrevy77ac-wvc-srcset",
  sizes: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=8vwyfanvenn-wvc-sizes"
}, {
  name: "DAVID NAVARRO",
  role: "Director de Ministerios Juveniles",
  bio: "Fomentando redes de conexión y avivamiento generacional para equipar a la próxima generación de líderes.",
  image: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/leader_doug_clay.png?v=2e45tr7smb9",
  srcset: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=fucqtvamsz-wvc-srcset",
  sizes: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=bz710ugspyi-wvc-sizes"
}, {
  name: "SOFÍA ORTIZ",
  role: "Coordinadora de Acción Social",
  bio: "Liderando proyectos de ayuda humanitaria, asistencia comunitaria y programas de desarrollo integral sostenible.",
  image: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=46c7qex549z",
  srcset: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=q9adk9tbsm-wvc-srcset",
  sizes: "https://current-thrush.10web.cloud/wp-content/uploads/2026/08/ricard.jpg?v=jhaql2bdb3a-wvc-sizes"
}];
const tickerItems = ["EXISTIMOS PARA ADORAR A DIOS", "EVANGELIZAR A LOS PERDIDOS", "DISCIPULAR A LOS CREYENTES", "MOSTRAR COMPASIÓN A LOS DEMÁS"];
export default function Leadership() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const shouldReduceMotion = useReducedMotion();
  const handleScroll = (direction: "left" | "right") => {
    if (scrollContainerRef.current) {
      const scrollAmount = 320;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth"
      });
    }
  };
  return <section id="executiveleadership" data-nav="light" className="relative w-full bg-background text-foreground overflow-hidden py-12 md:py-20">
      {/* Ticker */}
      <div className="w-full overflow-hidden border-y border-border/40 bg-muted/20 py-3 mb-12 sm:mb-16">
        <div className="flex whitespace-nowrap overflow-hidden">
          <div className="flex shrink-0 items-center gap-8 animate-marquee">
            {[...tickerItems, ...tickerItems, ...tickerItems, ...tickerItems].map((item, idx) => <div key={idx} className="flex items-center gap-6 font-semibold tracking-wider text-xs md:text-sm text-foreground/80 uppercase">
                <span>{item}</span>
                <Sparkles className="size-4 text-destructive shrink-0" aria-hidden="true" />
              </div>)}
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Header Section */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10 md:mb-14">
          <div className="w-full max-w-3xl">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground flex flex-wrap items-center gap-x-4 gap-y-2">
              <span>NUESTRO LIDERAZGO</span>
              <span className="bg-destructive text-destructive-foreground px-4 py-1 rounded-full text-2xl sm:text-3xl lg:text-4xl font-extrabold shadow-sm whitespace-nowrap">
                EJECUTIVO
              </span>
            </h2>
            <p className="mt-4 text-muted-foreground text-base sm:text-lg lg:whitespace-nowrap">
              Guiando a la fraternidad con visión, integridad espiritual y liderazgo de servicio.
            </p>
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center gap-2 self-start lg:self-auto">
            <Button variant="outline" size="icon" className="rounded-full size-11 border-border/80 hover:bg-muted text-foreground" onClick={() => handleScroll("left")} aria-label="Desplazar a la izquierda">
              <ChevronLeft className="size-5" />
            </Button>
            <Button variant="outline" size="icon" className="rounded-full size-11 border-border/80 hover:bg-muted text-foreground" onClick={() => handleScroll("right")} aria-label="Desplazar a la derecha">
              <ChevronRight className="size-5" />
            </Button>
          </div>
        </div>

        {/* Grid Cards */}
        <div ref={scrollContainerRef} className="grid grid-flow-col auto-cols-[85%] sm:auto-cols-[45%] lg:grid-flow-row lg:grid-cols-4 gap-6 overflow-x-auto lg:overflow-visible pb-4 lg:pb-0 snap-x snap-mandatory scrollbar-none">
          {leaders.map((leader, i) => <motion.div key={leader.name} data-index={i} initial={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-50px"
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="snap-start group relative flex flex-col justify-between h-[450px] sm:h-[480px] rounded-3xl overflow-hidden bg-card border border-border/60 shadow-md transition-all duration-300 hover:shadow-xl">
              <div className="absolute inset-0 z-0">
                <img src={leader.image} data-wvc-srcset={leader.srcset} data-wvc-sizes={leader.sizes} alt={leader.name} loading="lazy" decoding="async" className="w-full h-full object-cover object-top transition-transform duration-500 ease-out group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              </div>

              <div className="relative z-10 flex justify-end p-5">
                <div className="size-10 rounded-full bg-background/90 text-foreground flex items-center justify-center shadow-md backdrop-blur-xs transition-transform duration-300 group-hover:scale-110">
                  <ArrowUpRight className="size-5" />
                </div>
              </div>

              <div className="relative z-10 p-3 sm:p-4">
                <div className="bg-background/95 backdrop-blur-md rounded-2xl p-4 sm:p-5 border border-border/40 shadow-lg">
                  <h3 className="text-base sm:text-lg font-bold tracking-wide text-foreground uppercase">{leader.name}</h3>
                  <p className="text-xs sm:text-sm font-medium text-muted-foreground mt-0.5">{leader.role}</p>
                  <p className="text-xs text-muted-foreground/90 mt-2 line-clamp-2 leading-relaxed">{leader.bio}</p>
                  <div className="mt-3 pt-2 border-t border-border/50">
                    <Button variant="default" size="sm" className="w-full justify-between rounded-full text-xs font-semibold uppercase tracking-wider h-8 px-3.5 bg-foreground text-background">
                      <span>Conocer más</span>
                      <ArrowUpRight className="size-3.5" />
                    </Button>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}